/* v5.13 (Nov 3, John: "thumbnails too small"): tap/click-to-enlarge for the closing-gift + business-gift builders.
   Any element with data-zoom="<product handle>" (or data-zoom-group, see open()) opens a full-screen lightbox: the tapped photo first, then that product's other photos
   (from /products/<handle>.js, max 6) at width=1200. Arrows / swipe / ←→ move, X / Esc / tap outside close.
   Click is caught in the capture phase, so tapping a photo never ticks or unticks the item.
   Scroll lock: on desktop Horizon scrolls .page-wrapper (html is overflow:hidden), on phones html scrolls; lock whichever really scrolls,
   and move focus with preventScroll so nothing jumps (see the v5.11 freeze fix). */
(function () {
  if (window.CTT_ZOOM) return; window.CTT_ZOOM = 1;
  var css = '.ctt-zoom{position:relative;display:block;padding:0;margin:0;border:0;background:none;cursor:zoom-in;line-height:0}' +
    '.ctt-zoom-ico{position:absolute;right:6px;bottom:6px;width:26px;height:26px;border-radius:50%;background:rgba(250,247,242,.92);box-shadow:0 0 0 1px rgba(31,42,68,.12);display:flex;align-items:center;justify-content:center;pointer-events:none}' +
    '.ctt-zoom-ico svg{width:13px;height:13px}' +
    '.bz-zimg{position:relative;display:block;cursor:zoom-in}' +
    '.ctt-lb{position:fixed;inset:0;z-index:2147483000;background:#FAF7F2;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .18s;touch-action:pan-y;-webkit-tap-highlight-color:transparent}' +
    '.ctt-lb[hidden]{display:none}.ctt-lb.on{opacity:1}' +
    '.ctt-lb img{max-width:min(92vw,1100px);max-height:82vh;max-height:82dvh;width:auto;height:auto;object-fit:contain;background:#F7F3EC;user-select:none;-webkit-user-drag:none}' +
    '.ctt-lb button{position:absolute;border:0;background:none;padding:0;cursor:pointer;color:#111;display:flex;align-items:center;justify-content:center;width:48px;height:48px}' +
    '.ctt-lb .x{top:max(10px,env(safe-area-inset-top));right:10px}' +
    '.ctt-lb .pv{left:6px;top:50%;margin-top:-24px}.ctt-lb .nx{right:6px;top:50%;margin-top:-24px}' +
    '.ctt-lb svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1}' +
    '.ctt-lb p{position:absolute;bottom:max(18px,env(safe-area-inset-bottom));left:0;right:0;margin:0;text-align:center;font-size:10.5px;letter-spacing:.26em;text-transform:uppercase;color:#1F2A44}' +
    '.ctt-lb [hidden]{display:none}' +
    '@media (min-width:750px){.ctt-lb .pv{left:24px}.ctt-lb .nx{right:24px}.ctt-lb .x{top:20px;right:24px}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var ICO = '<svg viewBox="0 0 16 16" fill="none" stroke="#111" stroke-width="1.4"><circle cx="7" cy="7" r="4.6"/><path d="M10.4 10.4L14 14"/></svg>';
  window.CTT_ZOOM_ICO = '<span class="ctt-zoom-ico" aria-hidden="true">' + ICO + '</span>';
  var cache = {}, box, pic, cnt, pv, nx, list = [], alts = [], at = 0, opener = null, lockEl = null, lockOld = '';
  function big(u) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    u = u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
  }
  function key(u) { return (u || '').split('?')[0].replace(/^https?:/, ''); }
  function scroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && /auto|scroll/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight) return pw;
    return document.documentElement;
  }
  function build() {
    box = document.createElement('div'); box.className = 'ctt-lb'; box.hidden = true;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Photo');
    box.innerHTML = '<img alt="">' +
      '<button type="button" class="x" aria-label="Close"><svg viewBox="0 0 24 24"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
      '<button type="button" class="pv" aria-label="Previous photo"><svg viewBox="0 0 24 24"><path d="M15 4l-8 8 8 8"/></svg></button>' +
      '<button type="button" class="nx" aria-label="Next photo"><svg viewBox="0 0 24 24"><path d="M9 4l8 8-8 8"/></svg></button><p></p>';
    document.body.appendChild(box);
    pic = box.querySelector('img'); cnt = box.querySelector('p'); pv = box.querySelector('.pv'); nx = box.querySelector('.nx');
    box.addEventListener('click', function (e) {
      if (e.target.closest('.pv')) return go(-1);
      if (e.target.closest('.nx')) return go(1);
      if (e.target === pic) return list.length > 1 ? go(1) : null;
      close();   // the X, the backdrop or the counter
    });
    var x0 = null, y0 = 0;
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { e.preventDefault(); go(dx < 0 ? 1 : -1); }
    });
  }
  function show() {
    pic.src = list[at]; pic.alt = alts[at] || (opener && opener.getAttribute('data-zoom-alt')) || '';
    var many = list.length > 1; pv.hidden = nx.hidden = !many; cnt.textContent = many ? (at + 1) + ' / ' + list.length : '';
    if (many) { var n = new Image(); n.src = list[(at + 1) % list.length]; }
  }
  function go(d) { if (list.length < 2) return; at = (at + d + list.length) % list.length; show(); }
  function key2(e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight') go(1); else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'Tab') {   // keep focus inside the dialog
      var f = [].filter.call(box.querySelectorAll('button'), function (b) { return !b.hidden; }), i = f.indexOf(document.activeElement);
      e.preventDefault(); f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus({ preventScroll: true });
    }
  }
  function open(el) {
    if (!box) build();
    opener = el; var first = big(el.getAttribute('data-zoom-src') || (el.tagName === 'IMG' ? el.currentSrc || el.src : (el.querySelector('img') || {}).src));
    list = [first]; alts = []; at = 0;
    // gallery mode (v5.13, Coming Soon): data-zoom-group="x" pages through every photo in that group, in page order; no product fetch
    var grp = el.getAttribute('data-zoom-group');
    if (el.__img) {   // v5.15 site-wide auto mode: every auto photo in the same section (or open dialog), in page order
      grp = 'auto';
      if (el.__ss) el.__img = [].filter.call(el.__ss.querySelectorAll('img'), function (i) { return i.getBoundingClientRect().width > 0; })[0] || el.__img;
      var sec = el.__img.closest('dialog[open], [id^="shopify-section"], main') || document.body;
      var ims = [].filter.call(sec.querySelectorAll('img[data-ctt-z]'), function (i) { return i.getBoundingClientRect().width > 0; });
      if (ims.indexOf(el.__img) < 0) ims = [el.__img];
      list = ims.map(function (i) { return big(i.currentSrc || i.src); }); alts = ims.map(function (i) { return i.alt || ''; });
      at = Math.max(0, ims.indexOf(el.__img));
    } else if (grp) {
      var els = [].slice.call(document.querySelectorAll('[data-zoom-group="' + grp + '"]'));
      list = els.map(function (g) { return big(g.getAttribute('data-zoom-src') || (g.querySelector('img') || {}).src); });
      alts = els.map(function (g) { return g.getAttribute('data-zoom-alt') || ''; }); at = Math.max(0, els.indexOf(el));
    }
    var host = el.closest('dialog[open]') || document.body;   // a modal <dialog> (cart drawer) sits in the top layer: open inside it
    if (box.parentNode !== host) host.appendChild(box);
    show();
    lockEl = scroller(); lockOld = lockEl.style.overflow; lockEl.style.overflow = 'hidden';
    box.hidden = false; requestAnimationFrame(function () { box.classList.add('on'); });
    box.querySelector('.x').focus({ preventScroll: true });
    var h = el.getAttribute('data-zoom');
    if (grp || !h) return;
    (cache[h] || (cache[h] = fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })))
      .then(function (p) {
        if (!p || opener !== el || box.hidden) return;
        var seen = {}; seen[key(first)] = 1;
        var more = (p.images || []).map(big).filter(function (u) { var k = key(u); if (seen[k]) return false; seen[k] = 1; return true; });
        list = [first].concat(more).slice(0, 6); show();
      });
  }
  function close() {
    if (!box || box.hidden) return;
    box.classList.remove('on'); box.hidden = true; pic.removeAttribute('src');
    if (lockEl) { lockEl.style.overflow = lockOld; lockEl = null; }
    if (opener && opener.focus && opener.tagName === 'BUTTON') opener.focus({ preventScroll: true });
    opener = null;
  }
  // capture phase: runs before the builders' own click handlers, so the photo never toggles the item
  // v5.15: on window (runs before any document/card listener); press events are swallowed too, so a product card that
  // navigates on pointerdown/up never sees a tap on the magnifier
  function zt(e) { var el = e.target.closest && e.target.closest('[data-zoom]'); return el && !(box && box.contains(el)) ? el : null; }
  addEventListener('click', function (e) { var el = zt(e); if (!el) return; e.preventDefault(); e.stopImmediatePropagation(); open(el); }, true);
  ['pointerdown', 'pointerup', 'mousedown', 'mouseup'].forEach(function (t) {
    addEventListener(t, function (e) { if (zt(e) && zt(e).classList.contains('ctt-zoom-auto')) e.stopImmediatePropagation(); }, true);
  });
  document.addEventListener('keydown', key2);

  /* v5.15 (Nov 3, John: "the whole website has the magnifying glass"): site-wide auto mode.
     Every content photo shown small gets a magnifier button (bottom-right of the photo). The button opens the lightbox and
     never navigates / adds to cart (capture-phase click above); the card itself still links as before. A photo that is not inside a link,
     button or label opens on a tap of the photo too. Skipped: header, footer, menus, logos/icons/svg, full-width heroes, photos the
     builders / Coming Soon already wire, and the product-page gallery (the theme's own full-screen zoom handles it). */
  var SKIP = 'header, footer, .footer, nav, .mega-menu, .ctt-lb, [data-zoom], .ctt-zoom, .bz-zimg, [data-no-zoom], .lx-hero, media-gallery, .slideshow-control, .sticky-add-to-cart, .ctt-fc-logo, .ctt-pk, .search-modal__content';
  var BAD = /\.svg|logo|gcfd|signature-banner|icon|badge|payment/i;
  var marked = [];
  function ok(i) {
    if (i.hasAttribute('data-ctt-z') || i.closest(SKIP)) return false;
    var src = i.currentSrc || i.src || '';
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src) || BAD.test(src) || BAD.test(i.className || '')) return false;
    if (i.getAttribute('role') === 'presentation' || i.closest('[aria-hidden="true"]')) return false;
    var r = i.getBoundingClientRect(), st = getComputedStyle(i);
    if (r.width < 44 || r.height < 44 || st.opacity === '0' || st.visibility === 'hidden') return false;
    if (r.width >= Math.min(innerWidth * 0.96, 1000)) return false;   // full-bleed photos are already big
    return true;
  }
  function place(b) {
    var i = b.__ss || b.__img, h = b.parentNode; if (!h) return;
    var ir = i.getBoundingClientRect(), hr = h.getBoundingClientRect();
    var sm = ir.width < 90, d = sm ? 26 : 38; b.classList.toggle('sm', sm);   // small thumbnails (cart lines) get a smaller magnifier
    b.hidden = ir.width < 44;
    b.style.top = Math.round(ir.bottom - hr.top - d) + 'px'; b.style.left = Math.round(ir.right - hr.left - d) + 'px';
  }
  var ro = window.ResizeObserver ? new ResizeObserver(function (es) { es.forEach(function (e) { if (e.target.__zb) place(e.target.__zb); }); }) : null;
  function wire(i) {
    i.setAttribute('data-ctt-z', '');
    var link = i.closest('a, button, label');
    var h = i.parentNode; if (h.tagName === 'PICTURE') h = h.parentNode;
    // product cards show their photos in a slideshow (hover swaps the slide): one magnifier per slideshow, pinned to it, opening the slide on show
    var ss = i.closest('slideshow-container');
    if (ss) {
      [].forEach.call(ss.querySelectorAll('img'), function (x) { x.setAttribute('data-ctt-z', ''); });
      if (ss.__zb) return;
      h = ss;
    }
    if (getComputedStyle(h).position === 'static') h.style.position = 'relative';
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'ctt-zoom-auto'; b.setAttribute('data-zoom', ''); b.setAttribute('aria-label', 'Enlarge photo' + (i.alt ? ': ' + i.alt : ''));
    b.innerHTML = ICO; b.__img = i; b.__ss = ss; i.__zb = b; if (ss) ss.__zb = b; h.appendChild(b); place(b); marked.push(b);
    if (ro) ro.observe(ss || i);
    if (!link) { i.setAttribute('data-zoom', ''); i.__img = i; i.style.cursor = 'zoom-in'; }
  }
  function scan() { [].forEach.call(document.images, function (i) { if (ok(i)) wire(i); }); marked.forEach(place); }
  st.textContent += '.ctt-zoom-auto{position:absolute;z-index:3;width:30px;height:30px;padding:0;margin:0;border:0;border-radius:50%;background:rgba(250,247,242,.92);box-shadow:0 0 0 1px rgba(31,42,68,.12);display:flex;align-items:center;justify-content:center;cursor:zoom-in;-webkit-tap-highlight-color:transparent}' +
    '.ctt-zoom-auto.sm{width:22px;height:22px}.ctt-zoom-auto.sm svg{width:10px;height:10px}.ctt-zoom-auto::before{content:"";position:absolute;inset:-7px}.ctt-zoom-auto[hidden]{display:none}.ctt-zoom-auto svg{width:13px;height:13px}' +
    '.ctt-zoom-auto:focus-visible{outline:2px solid #B08D57;outline-offset:2px}';
  var t = 0;
  function later() { clearTimeout(t); t = setTimeout(scan, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
  addEventListener('load', later); addEventListener('resize', later);
  document.addEventListener('load', function (e) { if (e.target.tagName === 'IMG') later(); }, true);
  new MutationObserver(function (ms) {
    for (var k = 0; k < ms.length; k++) if (!(box && box.contains(ms[k].target)) && !(ms[k].target.closest && ms[k].target.closest('.ctt-zoom-auto'))) { later(); return; }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'hidden'] });
})();
